package com.kaihuoy.components.common

import androidx.compose.runtime.*
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import com.kaihuoy.components.common.*

@Composable
fun StyledButton(
    text: String,
    onClick: () -> Unit,
    backgroundColor: CSSColorValue? = null,
    enabled: Boolean = true,
    isSelected: Boolean = false,
    icon: String? = null

) {
    var isHovered by remember { mutableStateOf(false) }

    val bgColor = when {
        isSelected -> KaihuTheme.PrimaryTeal
        backgroundColor != null -> backgroundColor
        else -> KaihuTheme.Primary
    }

    Button(
        attrs = {
            onClick { if (enabled) onClick() }
            if (!enabled) attr("disabled", "true")
            
            onMouseEnter { isHovered = true }
            onMouseLeave { isHovered = false }

            style {
                padding(12.px, 24.px)
                borderRadius(10.px)
                border(0.px)
                fontSize(1.em)
                fontWeight("500")
                cursor(if (enabled) "pointer" else "not-allowed")
                backgroundColor(bgColor)
                color(KaihuTheme.OnPrimary)
                property("box-shadow", if (isHovered && enabled) KaihuTheme.ShadowMd else KaihuTheme.ShadowSm)
                property("transition", "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)")
                minWidth(120.px)
                
                if (isHovered && enabled) {
                    property("transform", "translateY(-1px)")
                    property("filter", "brightness(1.1)")
                }

                if (!enabled) {
                    opacity(0.6)
                    property("filter", "grayscale(0.5)")
                }

                // Valittu nappi - selkeä korostus
                if (isSelected) {
                    backgroundColor(KaihuTheme.PrimaryTeal)
                    property("box-shadow", "0 0 0 3px rgba(20, 184, 166, 0.3)")
                }
            }
        }
    ) {
        if (icon != null) {
            TIcon(icon)
            Text(" $text")
        } else {
            Text(text)
        }
    }
}
@Composable
fun LogOutButton(
    text: String,
    onClick: () -> Unit,
    backgroundColor: CSSColorValue? = null,
    enabled: Boolean = true,
    isSelected: Boolean = false,
    icon: String? = null,
    accentHex: String ="#EF4444"

) {
    var hovered by remember { mutableStateOf(false) }

    val bgColor = when {
        isSelected -> KaihuTheme.PrimaryTeal
        backgroundColor != null -> backgroundColor
        else -> KaihuTheme.Primary
    }

    Button(
        attrs = {
            onClick { if (enabled) onClick() }
            onMouseEnter { hovered = true }
            onMouseLeave { hovered = false }


            style {
                padding(12.px, 24.px)
                borderRadius(10.px)
                border(0.px)
                fontSize(1.em)
                fontWeight("500")
                cursor(if (enabled) "pointer" else "not-allowed")
                backgroundColor(bgColor)
                color(KaihuTheme.OnPrimary)
                property("box-shadow", if (hovered && enabled) KaihuTheme.ShadowMd else KaihuTheme.ShadowSm)
                property("transition", "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)")
                minWidth(120.px)

                if (hovered && enabled) {
                    property("transform", "translateY(-1px)")
                    property("filter", "brightness(1.1)")
                    property("border", "1px solid ${if (hovered) accentHex else "#2a2f45"}")
                    property("transition", "all 0.18s")
                    property("background", if (hovered) "linear-gradient(135deg, ${accentHex}22 0%, ${accentHex}0a 100%)" else "linear-gradient(135deg, #1e2235 0%, #131625 100%)")
                    property("box-shadow", if (hovered) "0 4px 16px ${accentHex}33" else "none")
                }

                if (!enabled) {
                    opacity(0.6)
                    property("filter", "grayscale(0.5)")
                }

                // Valittu nappi - selkeä korostus
                if (isSelected) {
                    backgroundColor(KaihuTheme.PrimaryTeal)
                    property("box-shadow", "0 0 0 3px rgba(20, 184, 166, 0.3)")
                }
            }
        }
    ) {

        Text(text)

    }
}

@Composable
fun LDelButton(
    text: String,
    onClick: () -> Unit,
    backgroundColor: CSSColorValue? = null,
    enabled: Boolean = true,
    isSelected: Boolean = false,
    icon: String? = null

) {
    var isHovered by remember { mutableStateOf(false) }

    val bgColor = when {
        isSelected -> KaihuTheme.Danger
        backgroundColor != null -> backgroundColor
        else -> KaihuTheme.Danger
    }

    Button(
        attrs = {
            onClick { if (enabled) onClick() }
            if (!enabled) attr("disabled", "true")

            onMouseEnter { isHovered = true }
            onMouseLeave { isHovered = false }

            style {
                padding(12.px, 24.px)
                borderRadius(10.px)
                border(0.px)
                fontSize(1.em)
                fontWeight("500")
                cursor(if (enabled) "pointer" else "not-allowed")
                backgroundColor(bgColor)
                color(KaihuTheme.OnPrimary)
                property("box-shadow", if (isHovered && enabled) KaihuTheme.ShadowMd else KaihuTheme.ShadowSm)
                property("transition", "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)")
                minWidth(120.px)

                if (isHovered && enabled) {
                    property("transform", "translateY(-1px)")
                    property("filter", "brightness(1.1)")
                }

                if (!enabled) {
                    opacity(0.6)
                    property("filter", "grayscale(0.5)")
                }

                // Valittu nappi - selkeä korostus
                if (isSelected) {
                    backgroundColor(KaihuTheme.PrimaryTeal)
                    property("box-shadow", "0 0 0 3px rgba(20, 184, 166, 0.3)")
                }
            }
        }
    ) {
        if (icon != null) {
            TIcon(icon)
            Text(" $text")
        } else {
            Text(text)
        }
    }
}